import {Injectable, Injector} from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import {Router} from '@angular/router';

import {UsermgmtService} from 'src/app/services/usermgmt.service';
import {AlertManagerService} from 'src/app/services/alert-manager.service';
import {RollbarService} from 'src/app/rollbar';

@Injectable({
  providedIn: 'root',
})
export class ServerErrorInterceptorService implements HttpInterceptor {

  constructor(private alertService: AlertManagerService,
              private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          const rollbar = this.injector.get(RollbarService);
          const userService = this.injector.get(UsermgmtService);
          const router = this.injector.get(Router);

          if (error.error instanceof ErrorEvent) {
          // client side error
          } else {
          // server side error
            if (error.status === 401) {
            // If the client uses an invalid token delete the locally stored one
            // TODO: improve api error for easier checking
              if (error.error.detail === 'Invalid token.') {
                userService.deleteStoredUserData();
              }
              if (request.url.includes('/api/auth/login/')) {
                this.alertService.presentLoginFailedAlert();
                return throwError(error);
              } else {
                // For any other 401 error, redirect to login page
                userService.deleteStoredUserData();
                router.navigate(['/login']);
                return throwError(error);
              }
            }
          }
          rollbar.error(new Error(error.message).stack);
          return throwError(error);
        }),
    );
  }
}
